import React, { useEffect, useState } from 'react';
import { useHiddenMode } from '../contexts/HiddenModeContext';

const HiddenModeDebug: React.FC = () => {
  const { isHiddenModeActive, showHiddenItems, hideHiddenItems } = useHiddenMode();
  const [lastKeyPressed, setLastKeyPressed] = useState<string>('');
  
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Track key combinations for debugging
      const keys = [];
      if (event.altKey) keys.push('Alt');
      if (event.ctrlKey) keys.push('Ctrl');
      if (event.shiftKey) keys.push('Shift');
      keys.push(event.key);
      setLastKeyPressed(keys.join('+'));
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  return (
    <div style={{
      position: 'fixed',
      top: '100px',
      right: '10px',
      background: isHiddenModeActive ? '#4CAF50' : '#f44336',
      color: 'white',
      padding: '12px',
      borderRadius: '6px',
      fontSize: '12px',
      zIndex: 9999,
      fontFamily: 'monospace',
      display: 'none',
      minWidth: '280px'
    }}>
      🔐 Hidden Mode: {isHiddenModeActive ? 'ACTIVE' : 'INACTIVE'}
      <br />
      <small>Show: Alt+Ctrl+Shift+6/H/^ | Hide: Escape/Alt+Ctrl+Shift+X/Ctrl+Ctrl</small>
      <br />
      <small style={{ color: '#ffeb3b' }}>Last key: {lastKeyPressed || 'none'}</small>
      <br />
      <div style={{ marginTop: '8px', display: 'flex', gap: '4px' }}>
        <button 
          onClick={isHiddenModeActive ? hideHiddenItems : showHiddenItems}
          style={{
            padding: '4px 8px',
            fontSize: '10px',
            border: 'none',
            borderRadius: '3px',
            cursor: 'pointer',
            backgroundColor: isHiddenModeActive ? '#dc3545' : '#28a745',
            color: 'white'
          }}
        >
          {isHiddenModeActive ? 'Hide' : 'Show'}
        </button>
        
        <button 
          onClick={() => {
            console.log('Keyboard shortcut test - check console');
            alert('Try pressing Alt+Ctrl+Shift+6 now!');
          }}
          style={{
            padding: '4px 8px',
            fontSize: '10px',
            border: 'none',
            borderRadius: '3px',
            cursor: 'pointer',
            backgroundColor: '#007bff',
            color: 'white'
          }}
        >
          Test
        </button>
      </div>
    </div>
  );
};

export default HiddenModeDebug;
